import { USER_PANEL_CREATE } from 'client/redux/user/constants';
import * as actions from 'client/redux/user/actionCreators';

export const userNewPanelCreate = fields => dispatch => {
  return dispatch(actions.userCreate(USER_PANEL_CREATE, fields));
};
